import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { RadioButton } from 'primereact/radiobutton';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';

import useEditPage from 'hooks/useEditPage';
const CredittblEditPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		fullname: yup.string().required().label($t('fullname')),
		firstname: yup.string().required().label($t('firstname')),
		middlename: yup.string().nullable().label($t('middlename')),
		lastname: yup.string().required().label($t('lastname')),
		dob: yup.string().required().label($t('dob')),
		gender: yup.string().required().label($t('gender')),
		additionalname1: yup.string().nullable().label($t('husbandName')),
		additionalname2: yup.string().nullable().label($t('fatherName')),
		nationalid: yup.string().min(16).min(16).required().label($t('nationalid')),
		pancard: yup.string().min(12).required().label($t('pancard')),
		voterid: yup.string().nullable().label($t('voterid')),
		mobile: yup.string().required().label($t('mobile')),
		addrline1: yup.string().required().label($t('addrline1')),
		city: yup.string().required().label($t('city')),
		state: yup.string().required().label($t('state')),
		postal: yup.string().required().label($t('postal')),
		maritalstatus: yup.string().required().label($t('maritalstatus')),
		userid: yup.number().nullable().label($t('userid')),
		check_date: yup.string().nullable().label($t('checkDate'))
	});
	// form default values
	const formDefaultValues = {
		fullname: '', 
		firstname: '', 
		middlename: '', 
		lastname: '', 
		dob: new Date(), 
		gender: '', 
		additionalname1: '', 
		additionalname2: '', 
		nationalid: '', 
		pancard: '', 
		voterid: '', 
		mobile: '', 
		addrline1: '', 
		city: '', 
		state: '', 
		postal: '', 
		maritalstatus: '', 
		userid: auth.userId, 
		check_date: "(CONVERT([date],getdate()))", 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/credittbl`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="CredittblEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('editCredittbl')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('fullname')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="fullname"  onChange={formik.handleChange}  value={formik.values.fullname}   label={$t('fullname')} type="text" placeholder={$t('enterFullname')}        className={inputClassName(formik?.errors?.fullname)} />
                                                <ErrorMessage name="fullname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('firstname')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="firstname"  onChange={formik.handleChange}  value={formik.values.firstname}   label={$t('firstname')} type="text" placeholder={$t('enterFirstname')}        className={inputClassName(formik?.errors?.firstname)} />
                                                <ErrorMessage name="firstname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('middlename')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="middlename"  onChange={formik.handleChange}  value={formik.values.middlename}   label={$t('middlename')} type="text" placeholder={$t('enterMiddlename')}        className={inputClassName(formik?.errors?.middlename)} />
                                                <ErrorMessage name="middlename" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('lastname')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="lastname"  onChange={formik.handleChange}  value={formik.values.lastname}   label={$t('lastname')} type="text" placeholder={$t('enterLastname')}        className={inputClassName(formik?.errors?.lastname)} />
                                                <ErrorMessage name="lastname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('dob')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="dob" showButtonBar className={inputClassName(formik?.errors?.dob)} dateFormat="yy-mm-dd" value={formik.values.dob} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="dob" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('gender')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                {
                                                app.menus.gender2.map((option) => {
                                                return (
                                                <div key={option.value} className="field-radiobutton">
                                                    <RadioButton inputId={option.value} name="gender" value={option.value} onChange={formik.handleChange}  checked={formik.values.gender === option.value} className={inputClassName(formik?.errors?.gender, '')} />
                                                    <label htmlFor={option.value}>{option.label}</label>
                                                </div>
                                                )
                                                })
                                                }
                                                <ErrorMessage name="gender" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('husbandName')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="additionalname1"  onChange={formik.handleChange}  value={formik.values.additionalname1}   label={$t('husbandName')} type="text" placeholder={$t('enterHusbandName')}        className={inputClassName(formik?.errors?.additionalname1)} />
                                                <ErrorMessage name="additionalname1" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('fatherName')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="additionalname2"  onChange={formik.handleChange}  value={formik.values.additionalname2}   label={$t('fatherName')} type="text" placeholder={$t('enterFatherName')}        className={inputClassName(formik?.errors?.additionalname2)} />
                                                <ErrorMessage name="additionalname2" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('nationalid')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="nationalid"  onChange={formik.handleChange}  value={formik.values.nationalid}   label={$t('nationalid')} type="text" placeholder={$t('enterNationalid')}        className={inputClassName(formik?.errors?.nationalid)} />
                                                <ErrorMessage name="nationalid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('pancard')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="pancard"  onChange={formik.handleChange}  value={formik.values.pancard}   label={$t('pancard')} type="text" placeholder={$t('enterPancard')}        className={inputClassName(formik?.errors?.pancard)} />
                                                <ErrorMessage name="pancard" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('voterid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="voterid"  onChange={formik.handleChange}  value={formik.values.voterid}   label={$t('voterid')} type="text" placeholder={$t('enterVoterid')}        className={inputClassName(formik?.errors?.voterid)} />
                                                <ErrorMessage name="voterid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('mobile')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="mobile"  onChange={formik.handleChange}  value={formik.values.mobile}   label={$t('mobile')} type="text" placeholder={$t('enterMobile')}        className={inputClassName(formik?.errors?.mobile)} />
                                                <ErrorMessage name="mobile" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('addrline1')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="addrline1"  onChange={formik.handleChange}  value={formik.values.addrline1}   label={$t('addrline1')} type="text" placeholder={$t('enterAddrline1')}        className={inputClassName(formik?.errors?.addrline1)} />
                                                <ErrorMessage name="addrline1" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('city')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="city"  onChange={formik.handleChange}  value={formik.values.city}   label={$t('city')} type="text" placeholder={$t('enterCity')}        className={inputClassName(formik?.errors?.city)} />
                                                <ErrorMessage name="city" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('state')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/state_option_list_2"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="state"     optionLabel="label" optionValue="value" value={formik.values.state} onChange={formik.handleChange} options={response} label={$t('state')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.state)}   />
                                                    <ErrorMessage name="state" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('postal')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="postal"  onChange={formik.handleChange}  value={formik.values.postal}   label={$t('postal')} type="text" placeholder={$t('enterPostal')}        className={inputClassName(formik?.errors?.postal)} />
                                                <ErrorMessage name="postal" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('maritalstatus')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/maritalstatus_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="maritalstatus"     optionLabel="label" optionValue="value" value={formik.values.maritalstatus} onChange={formik.handleChange} options={response} label={$t('maritalstatus')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.maritalstatus)}   />
                                                    <ErrorMessage name="maritalstatus" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('userid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="userid"  onChange={formik.handleChange}  value={formik.values.userid}   label={$t('userid')} type="number" placeholder={$t('enterUserid')}  min={0}  step="any" disabled   className={inputClassName(formik?.errors?.userid)} />
                                                <ErrorMessage name="userid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('checkDate')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="check_date" showButtonBar className={inputClassName(formik?.errors?.check_date)} dateFormat="yy-mm-dd" value={formik.values.check_date} onChange={formik.handleChange} showIcon     disabled   />
                                                <ErrorMessage name="check_date" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label={$t('update')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
CredittblEditPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'credittbl',
	apiPath: 'credittbl/edit',
	routeName: 'credittbledit',
	submitButtonLabel: $t('update'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('updateRecord'),
	msgAfterSave: $t('recordUpdatedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default CredittblEditPage;
